import { LocaleModule } from "./LocaleModule";

export const localeModules: LocaleModule[] = [];
